/**
 * ProductPartnerInfo Component will display product's partner info.
 *
 * @module views/components/ProductPartnerInfo
 * @memberof -Common
 */

import './ProductPartnerInfo.scss';

import React from 'react';

import PropTypes from 'prop-types';

import Button from '@ulta/core/components/Button/Button';
import Icon from '@ulta/core/components/Icon/Icon';
import Text from '@ulta/core/components/Text/Text';
import { spreadProps } from '@ulta/core/utils/dom/dom';

import PartnerInfoSheetContent from '../PartnerInfoSheetContent/PartnerInfoSheetContent';

/**
 * Represents a ProductPartnerInfo component
 *
 * @method
 * @param {partnerInfo} props - React properties passed from composition
 * @returns ProductPartnerInfo
 */
export const ProductPartnerInfo = ( props = {} ) => {
  const { partnerInfoSheet = {}, message, icon, action = {} } = props;
  const { title = {} } = partnerInfoSheet;
  return (
    <div className='ProductPartnerInfo'>
      <span className='ProductPartnerInfo__Text' >
        <Text
          textStyle='body-2'
          color='neutral-500'
        >
          { message }
        </Text>
      </span>
      { icon && (
        <span className={ 'ProductPartnerInfo__Icon' } >
          <Icon
            name={ icon }
            size='s'
            aria-hidden={ true }
          />
        </span>
      ) }
      { action.label && (
        <span className='sr-only'>{ action.label }</span>
      ) }
      <Button
        likeLink
        label={ action.label }
        className='ProductPartnerInfo__Button'
        crossButtonVisibility={ true }
        action={ {
          ...action,
          navigationType: 'bottomSheet'
        } }
        closeAction={ partnerInfoSheet.closeAction }
        overlayTitle={ {
          text: title.text,
          htmlTag: title.htmlTag,
          textStyle: 'title-lg'
        } }
        overlayContent={
          <PartnerInfoSheetContent { ...spreadProps( { ...partnerInfoSheet } ) } /> }
      />
    </div>
  );
};

/**
 * Property type definitions
 *
 * @typedef ProductDimensionProps
 * @type {object}
 * @property {object} partnerInfo - Sets the partnerInfo content
 * @property {object} partnerInfo.sheetContent - Sets the partnerInfo overlay content with title and description
 * @property {string} partnerInfo.icon - Sets the icon name of the disclaimer text
 * @property {string} partnerInfo.moduleName - Sets the module name for the component
 * @property {string} partnerInfo.message - Sets the content of the message on PDP
 */
export const propTypes =  {
  partnerInfo: PropTypes.shape( {
    partnerInfoSheet: PropTypes.object,
    icon: PropTypes.string,
    moduleName: PropTypes.string,
    message: PropTypes.string
  } )
};

ProductPartnerInfo.propTypes = propTypes;

export default ProductPartnerInfo;
